import { AccountingZipService } from "core/service";
import { AccountingZipPersistence } from "core/persistence";
import BaseRepository from "core/repository/base.repository";

class AccountingZipRepository extends BaseRepository {
  syncable = false;

  getEntityIdentifier() {
    return "accounting-zip";
  }

  resourceName() {
    return "zip";
  }

  getServiceProvider() {
    return AccountingZipService;
  }

  getPersistenceProvider() {
    return AccountingZipPersistence;
  }

  async fetch(month, year) {
    const currentUser = await this.mRuntime.get("currentUser");
    return await this.mService.fetch(currentUser.company_uuid, month, year);
  }
}

export default new AccountingZipRepository();



// WEBPACK FOOTER //
// ./src/core/repository/accounting-zip.repository.js